export default __webpack_public_path__ + "static/media/1067.5fc53cab.png";